import MobileDetect from 'mobile-detect';
import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import isNotNil from "ramda-extension/es/isNotNil";
import React, { cloneElement, Component, Fragment } from 'react';
import ReactTooltip from 'react-tooltip';
import InfoCircle from '../../../atoms/SvgIcon/Icons/InfoCircle';
import { withDefaultComponentProps } from '../../../decorators/withDefaultComponentProps';
const COMPONENT_NAME = 'Tooltip';
export const place = {
    TOP: 'top',
    BOTTOM: 'bottom',
    RIGHT: 'right',
    LEFT: 'left'
};
export const effect = {
    FLOAT: 'float',
    SOLID: 'solid'
};
class Tooltip extends Component {
    constructor(props){
        super(props);
        if (!props.id) {
            this._uniqueId = crypto.randomUUID();
        }
        this.md = new MobileDetect(window.navigator.userAgent);
    }
    render() {
        const { place, effect, className, id, tip, children, event, disable, hideIcon, eventOff, contentClassName, tipClassName, fitToViewport, inline, icon, overridePosition } = this.props;
        const uniqueId = id || this._uniqueId;
        const tooltipProps = {
            id: uniqueId,
            place,
            effect,
            disable,
            event,
            eventOff,
            ...overridePosition ? {
                overridePosition
            } : {}
        };
        if (this.md.mobile() || this.md.tablet() || this.md.phone()) {
            tooltipProps.isCapture = true;
            tooltipProps.event = 'click';
        }
        const iconElement = hideIcon ? /*#__PURE__*/ React.createElement(Fragment, null) : icon;
        return /*#__PURE__*/ React.createElement("div", {
            className: cx('Tooltip', {
                'Tooltip-inline': inline
            }, className)
        }, /*#__PURE__*/ React.createElement("div", {
            className: cx({
                'Tooltip-tip': hideIcon === false
            }, isNotNil(tipClassName) ? tipClassName : className),
            "data-tip": true,
            "data-class": cx('Tooltip-content', contentClassName),
            "data-for": uniqueId,
            "data-event": event
        }, /*#__PURE__*/ cloneElement(iconElement, {
            className: 'Tooltip-tip--left'
        }), tip, /*#__PURE__*/ cloneElement(iconElement, {
            className: 'Tooltip-tip--right'
        })), /*#__PURE__*/ React.createElement(ReactTooltip, {
            overridePosition: ({ left, top }, _e, _t, node)=>{
                if (fitToViewport) {
                    const d = document.documentElement;
                    left = Math.min(d.clientWidth - node.clientWidth, left);
                    top = Math.min(d.clientHeight - node.clientHeight, top);
                    left = Math.max(0, left);
                    top = Math.max(0, top);
                    return {
                        top,
                        left
                    };
                }
                return {
                    top,
                    left: typeof node === 'string' ? left : Math.max(left, 0)
                };
            },
            ...tooltipProps
        }, children));
    }
}
Tooltip.propTypes = {
    /**
	 * Body of tooltip itself (the 'popup' part)
	 */ children: PropTypes.node.isRequired,
    /**
	 * Root class name
	 */ className: PropTypes.string,
    /**
	 * Tooltip content class name
	 */ contentClassName: PropTypes.string,
    /**
	 * Disable tooltip
	 */ disable: PropTypes.bool,
    /**
	 * Behaviour of tooltip (float, solid)
	 */ effect: PropTypes.string,
    /**
	 * Event to show tooltip
	 */ event: PropTypes.string,
    /**
	 * Event off tooltip
	 */ eventOff: PropTypes.string,
    /**
	 * Tooltip will try to automatically fit content to viewport if overflow.
	 */ fitToViewport: PropTypes.bool,
    /**
	 * Hide icon (default false)
	 */ hideIcon: PropTypes.bool,
    /**
	 * Tooltip Icon node
	 */ icon: PropTypes.node,
    /**
	 * Id of tooltip element
	 */ id: PropTypes.string,
    /**
	 * Display tooltip with inline-block
	 */ inline: PropTypes.bool,
    /**
	 * React-tooltip overridePosition prop
	 */ overridePosition: PropTypes.func,
    /**
	 * Place of the tooltip element (top, right, bottom, left)
	 */ place: PropTypes.string,
    /**
	 * Static text to show as tooltip trigger
	 */ tip: PropTypes.node.isRequired,
    /**
	 * Tooltip tip class name
	 */ tipClassName: PropTypes.string
};
export { Tooltip };
export default withDefaultComponentProps(COMPONENT_NAME, {
    place: 'top',
    effect: 'solid',
    hideIcon: false,
    icon: /*#__PURE__*/ React.createElement(InfoCircle, null)
}, Tooltip);
